<template>
	<div>
		<Breadcrumbs main="" title="release.header"/>
		<!-- Container-fluid starts-->
		<div class="container-fluid search-page">
			<div class="row">
                <div class="col-sm-6 gradient-wy">
                    <form class="theme-form">
                        <h2 class=" text-dark f-w-600 ml-3">{{ $t('release.header') }}</h2>
                        <div class="row ml-1">
                            <div v-if="!showContInput" class="col-sm-5">
                                <div class="row ml-2">
                                    <label class="col-form-label pt-0 f-w-600" style="font-size:16px;">{{ $t("release.contNo") }}</label>  
                                    <router-link to="/resource/container">
                                        <feather  v-b-tooltip.hover :title="$t('container.add')" type="plus-circle" class="ml-2"></feather>
                                    </router-link>
                                </div>
                                <v-select  
                                    style="font-size:16px;" 
                                    v-model="selectedContId" 
                                    @input="setContId" 
                                    :options="contList"  
                                    :reduce="text => text.value"
                                    label = "text"
                                    :placeholder="$t('release.contNoPh')">       
                                    <template #no-options>
                                        {{$t('reuse.noMatchingOptions')}}
                                    </template>
                                </v-select>                            
                            </div>
                            <div v-else class="col-sm-5">
                                <router-link to="/resource/container">
                                    <b-button pill size="sm" class="bg-primary mb-4 mt-3 ml-3 ">
                                        <span class="f-w-600 text-white" style="font-size: 18px;">{{ $t('release.addContData') }} </span>
                                    </b-button>                                       
                                </router-link>
                            </div>
                            <div v-show="detTS != 0" class="col-sm-3 mt-2">
                                <label for="detTS" class="col-form-label pt-0 f-w-600" style="font-size: 16px">{{ $t("container.detDate") }}</label>
                                <p  class="from-control text-info" style="font-size:16px;">{{ $moment(detTS).format('YYYY-MM-DD') }} </p>
                            </div>   
                            <div class="col-sm-3 mt-2">
                                <label for="distLim" class="col-form-label pt-0 f-w-600" style="font-size:16px;">{{ $t("release.distLim") }}</label>
                                <input v-model="distLim" class="form-control" style="font-size:16px;" type="text" :placeholder="$t('release.distLimPh')" >
                            </div>                              
                        </div>   
                        <div class="form-group ml-4 mt-2 text-primary f-w-600">
                            <div class="row">
                                <label for="contRelsAddress" class="col-form-label pt-0 ml-3">{{ $t("release.locRels") }}</label>    
                                <p class=" ml-2 fw-bold text-danger"  > {{ $t("release.ifChg") }}</p>
                                <a href="#googleMapRels"><u class=" ml-2 fw-bold text-info" style="font-size:15px" @click="showAC"><i class="icofont icofont-map-search mr-2 " style="font-size:25px"></i> Google Map </u></a>                                
                            </div>
                            <!-- <input v-model="contRelsAddress" class="form-control text-info" type="text" id="contRelsAddress" :placeholder="$t('release.locRelsPh') " > -->
                            <span class="f-w-60 text-primary ml-2" style="font-size:14px;"> {{ contRelsAddress }}</span>
                            <h6 class=" ml-3 text-info"> Latitude : {{ locRels.lat }}  ,  Longitude : {{ locRels.lng }}</h6>
                        </div> 
                        <div class="row col-sm-12 ml-1" v-b-popover.hover.top="$t('release.startRelsDateInfo')">
                            <label class="f-w-600 mr-3" style="font-size:15px" >{{ $t("release.startRelsDate") }}</label>
                            <div class="row form-group ml-2">
                                <datepicker input-class="datepicker-here form-control digits" :disabled-dates="disabledDates" :format="format" v-model="sRelsDate" ></datepicker>
                            </div>                     
                        </div>                                   
                        <div class="row ml-1">
                            <div class="row form-group m-t-5 custom-radio-ml ml-3 " >
                                <h5 class="mr-3">{{ $t('release.jobType') }}</h5>
                                <b-form-group  v-slot="{ ariaDescribedby }">
                                    <b-form-radio-group
                                        class="text-info mx-2" 
                                        id="radio-group-jobType"
                                        v-model="jobType"
                                        @input="resetNoDeliver"
                                        :aria-describedby="ariaDescribedby"
                                        name="jobType"
                                        plain
                                    >
                                        <b-form-radio value="Either" v-b-popover.hover.top="$t('release.eitherInfo')">{{ $t('release.either') }}</b-form-radio>                                  
                                        <b-form-radio class="mr-5"  value="Deliver" v-b-popover.hover.top="$t('release.deliverInfo')">{{ $t('release.deliver') }}</b-form-radio>
                                        <b-form-radio class="mr-5" value="NoDeliver" v-b-popover.hover.top="$t('release.noDeliverInfo')">{{ $t('release.noDeliver') }}</b-form-radio>
                                    </b-form-radio-group>
                                </b-form-group> 
                            </div>
                        </div>  
                        <div v-show="jobType == 'Deliver' || jobType == 'Either'" class="col-sm-12">
                            <div class="row ml-1">
                                <h5 class=" col-form-label pt-0 f-w-600">{{ $t("release.transTruck") }}</h5>  
                                <h5 v-show="jobType == 'Either'" class="text-info ml-3"> {{ $t("release.EitherInfo") }}</h5>
                            </div>
                            <v-select 
                                class="style-chooser" 
                                style="font-size:16px;" 
                                :options="transCompList" 
                                :reduce="transName => transName.compId" 
                                v-model="selectedTransCompId"  
                                label="transName"
                                :placeholder="$t('release.transCompPh')"
                                > 
                            </v-select>  
                        </div>                             
                        <b-modal ref="rels-modal" size="lg" hide-footer :title= "$t('release.findingResult')">
                            <div class="d-block text-center">
                                <h4>{{ $t('release.noMatchingCont') }}</h4>
                            </div>
                            <b-button class="my-2" style="font-size:18px;" variant="outline-warning" block @click="doNotModal">
                                {{ $t('release.dontPost') }}
                            </b-button>                            
                            <div class="row col-sm-12 ">
                                <div class=" mt-3"> 
                                    <b-button variant="outline-info" block @click="postItModal">
                                        <span style="font-size: 18px;">
                                            {{ $t("release.postIt") }}
                                        </span> 
                                    </b-button>  
                                </div>  
                                <div class=" mt-3">
                                    <b-form-select  style="font-size:18px;" v-model="selectedPostQty" :options="postQtyList"></b-form-select>                            
                                </div>  
                                <div class=" mt-4">         
                                    <span class="text-primary" style="font-size: 18px;">
                                            {{ $t("release.units") }}
                                    </span>                                         
                                </div>            
                            </div> 
                            <div v-show="selectedPostQty > 1" class="ml-4 mt-1">
                                <h6 class="text-info">{{ $t('release.postContMsg1') }}</h6>
                                <h6 class="text-info">{{ $t('release.postContMsg2') }}</h6>
                                <h6 class="text-info">{{ $t('release.postContMsg3') }}</h6>
                                <h6 class="text-info">{{ $t('release.postContMsg4') }}</h6>
                            </div>
                        </b-modal>
                        <!-- </div> -->
                        <div class="form-group mt-3 mb-0">
                            <button 
                                class="btn btn-primary btn-block" 
                                style="font-size:20px" type="button" 
                                @click="handleSearching"
                                :disabled="this.selectedContId == '' || this.jobType == '' || this.sRelsDate == ''"
                                >
                                {{ $t('release.searching') }}
                            </button>
                        </div>
                    </form>
                </div>
                <div class="col-sm-6" id="googleMapRels">
                    <section class="ui one column centered grid mt-5" v-show="showAutoComplete"  style="position:relative; z-index: 5;">
                        <div class="column" >
                            <form class="ui left segment small form" >
                                <div class="ui message red" v-show="error">{{ error }}</div>
                                <!-- <div class="ui segment" > -->
                                    <div class="field" >
                                        <div class="row mb-3 col-sm-12">
                                            <div class=" col-sm-1">
                                                <i class="icon times text-primary" style="font-size: 24px;"  @click="offAC" ></i>                                                    
                                            </div>
                                            <div class="col-sm-11">
                                                <span class="text-warning"> {{ $t('company.donotEnterKey') }}</span>       
                                            </div>                              
                                        </div>
                                        <!-- <div class="ui message blue" >{{ compAddress }}</div> -->
                                        <div class="ui right icon input large" :class="{loading:spinner}">
                                            <input 
                                                type="text"
                                                v-b-popover.hover="$t('company.inputLocNameMsg')" 
                                                :title="$t('company.inputLocName')"                                                
                                                id="autocompleteRels"
                                                v-model="address"
                                                onkeypress= "return event.keyCode != 13"
                                            >
                                            <i 
                                                class="dot circle link icon" 
                                                @click="locatorButtonPressed"
                                                v-b-popover.hover.top="$t('company.useCurrPosition')"
                                            ></i>
                                        </div>
                                        <!-- dummy input to fix bug : only one input, make reload if we press ENTER.  -->
                                        <!-- <div class="ui message red" v-show="false">
                                            <input 
                                                type="text" 
                                            >
                                        </div> -->
                                    </div>

                                    <div class="row" @click="clearAddress">
                                        <i class="icon eraser f-10 ml-4 text-danger"  style="font-size: 18px;"></i>
                                        <span class="ml3 text-info" > {{ $t('company.clearAddress') }} </span>
                                        
                                    </div>
                                <!-- </div> -->
                            </form>                               
                        </div>
                    </section> 
                    <section id="mapRels" style="background-color: lightblue;"></section>   
                </div>
            </div>
            <b-alert v-model="showAlertWallet" variant="danger" dismissible class="col-sm-6">
                <h4 class="alert-heading f-w-800">{{ $t("release.walletCompNotEnough")}}</h4>
                <div class="row ml-1">
                    <span>{{ $t("release.balancedAmount") }}</span>
                    <span class="text-dark f-w-800 mx-2" style="font-size: 16px;">{{ balanced}}</span>
                    <span>{{ $t("refill.mUnit") }}</span>
                </div>
                <div>
                    <span>{{ $t("release.refillOrContact") }}</span>
                </div>
            </b-alert>
            <div class="row">
              <div class="col-md-12">
                <div class="card">
                      <h2 class="mb-1 mt-4 f-w-600">{{ $t('release.matchingList') }}</h2>
                      <div class="table-responsive datatable-vue">
                        <b-table
                            selectable
                            sticky-header
                            head-variant="light"
                            select-mode="single"
                            show-empty
                            responsive
                            sort-icon-left
                            stacked="md"
                            selectedVariant="primary"
                            :busy="isBusy"
                            :items="items"
                            :fields="tablefields"
                            :current-page="currentPage"
                            :per-page="perPage"
                            @row-selected="rowSelected"
                        >
                            <template #cell(addressReqr)="row" >
                                <b-button  size="sm"  v-b-popover.hover.top="row.item.contReqrAddress" variant="outline-info">
                                    {{ $t('matchTx.reqr') }}
                                </b-button>
                            </template>
                            <template #cell(selected)="{ rowSelected }">
                                <template v-if="rowSelected">
                                    <span aria-hidden="true">&check;</span>
                                    <span class="sr-only">{{ $t('require.selected') }}</span>
                                </template>
                                <template v-else>
                                    <span aria-hidden="true">&nbsp;</span>
                                    <span class="sr-only">{{ $t('require.notSelected') }}</span>
                                </template>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>{{ $t('require.loading') }}</strong>
                                </div>
                            </template>
                            <template #empty>
                                <h5>{{ $t('reuse.noRecord') }}</h5>
                            </template>
                            <!-- <template slot="action" slot-scope="row">
                              <b-button variant="danger" @click="selectRow(row.index)">Select</b-button>
                            </template>
                            <template slot="isDeleted" slot-scope="row">
                              {{ row.item ? 'Yes :)' : 'No :(' }}
                            </template> -->
                        </b-table>
                      </div>
                      <b-row>
                        <div class="col-sm-3 ">
                            <b-col class="my-1 ml-3">
                                <b-pagination
                                v-model="currentPage"
                                :total-rows="totalRows"
                                :per-page="perPage"
                                class="my-0"
                                ></b-pagination>
                            </b-col>                             
                        </div>
                        <div class="col-sm-5" >  
                            <b-col class="delete-datatable">
                                <b-button :disabled = "selected.length == 0 ? true : false"  variant="primary" @click="selectBatchRow" class="mb-1" style="font-size:20px">
                                    {{ $t("release.confirmSelected") }} <span class="position-absolute top-0 start-100 translate-middle badge rouned-pill bg-warning">{{ selected.length }}</span>   
                                </b-button>
                            </b-col>    
                            <!-- <b-col class="delete-datatable">
                                <b-button variant="primary" @click="selectRow(row.index)" class="mb-1" style="font-size:20px">
                                    {{ $t("release.confirmSelected") }} <span class="position-absolute top-0 start-100 translate-middle badge rouned-pill bg-warning">{{ selected.length }}</span>   
                                </b-button>
                            </b-col>                             -->
                        </div>          
                        <div class="col-sm-4 " >
                            <b-form-group label-cols="2" :label= "$t('require.perPage')" class="datatable-select">
                            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                            </b-form-group>
                        </div>      
                      </b-row>
                </div>
              </div>
            </div>
            <div class="divider"> </div>
            <div>
                <h2 class="mb-1 mt-4 f-w-600">{{ $t('release.postedRelease') }}</h2>
                <b-table
                    sticky-header
                    head-variant="light"
                    table-variant="success"
                    show-empty
                    responsive
                    sort-icon-left
                    stacked="md"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    :items="itemsPostedRels"
                    :fields="fieldsPostedRels"
                    :current-page="currentPagePostedRels"
                    :per-page="perPagePostedRels"
                >
                    <template #cell(addressRels)="row" >
                        <b-button  size="sm" v-b-popover.hover.top="row.item.contRelsAddress" variant="outline-info">
                            {{ $t('matchTx.rels') }}
                        </b-button>
                    </template>
                    <template #cell(actPostedRels)="row" >
                        <b-button  v-show="row.item.status == 'Release' " size="sm" @click="actPostedRelsCancel(row.item)" class="mb-1">
                            {{ $t('matchTx.cancel') }}
                        </b-button>
                    </template>
                    <template #empty>
                        <h5>{{ $t('reuse.noRecord') }}</h5>
                    </template>
                </b-table>
                <b-row>
                    <div class="row col-sm-8 ">
                    <b-col class="my-1 ml-3">
                        <b-pagination
                        v-model="currentPagePostedRels"
                        :total-rows="totalRowsPostedRels"
                        :per-page="perPagePostedRels"
                        align="fill"
                        class="my-0"
                        ></b-pagination>
                    </b-col>   
                    <b-col sm="3" md="6" class="my-1">
                        <b-form-group
                        :label= "$t('require.perPage')"
                        label-for="per-page-select"
                        label-cols-sm="6"
                        label-cols-md="4"
                        label-cols-lg="3"
                        label-align-sm="right"
                        label-size="sm"
                        class="mb-0"
                        >
                        <b-form-select
                            id="per-page-select"
                            v-model="perPagePostedRels"
                            :options="pageOptionsPostedRels"
                        ></b-form-select>
                        </b-form-group>
                    </b-col>
                    </div>
                </b-row>
                <!-- Info modal Reqr Attch Seal-->
            </div>

        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>
<script>

// const axios = require("axios");
import { transCompList, getBalance, uaTxWallet, agentAtContId, getStatusByDocId, compNameLocalByCompId,  updateStatus , updateActive, contIdList, locByCompId,saveWithId , getData, getDataWithinDays} from "../../firebase"
import {getRandomInt, showUserLocationOnTheMap} from "../../utilities/util" 
import {getAddressFrom , axiosPost} from "../../utilities/axiosComp" 
import {relsCost, qtyList} from '../../constants/config'
export default {
	data(){
		return{
            balanced: 0,
            showContInput : false,
            showAlertWallet: false,
            showAutoComplete : false,
            contList : [],
            postQtyList :[],
            transCompList : [],
            selectedTransCompId : '',
            sRelsDate: '',
            detTS : 0,  // for display and comparision
            disabledDates: {
                to: new Date(Date.parse(new Date())-86400000),  // today onward
            },
            address : '',
            error : '',        
            spinner: false,
            format: "yyyy-MM-dd",
            relsId: '',
            selectedContId : '',
            selectedPostQty : 1,
            agent: '',  // owner of cont. 
            selectedContData: '',  // for makeMatchTx
            compNameLocalRels: '',  // for Release and makeMatchTx 
            contRelsAddress: '',
            locRels : '',
            jobType : '', // =trans type
            userId: '',
            compId: '',
            distLim : '50',
            payload : '',
            relsQty : 1,
            isBusy: false,
            tablefields: [
                { key: 'selected', label: this.$t('require.selected'), sortable: true, variant: 'info' },
                { key: 'distance', label: this.$t('release.distance'), sortable: true, variant: 'info'},                  
                { key: 'id', label: this.$t('require.id'), sortable: true, },  
                { key: 'bkgId', label: this.$t('release.bkgId'), sortable: true, },
                { key: 'agent', label: this.$t('release.agent'), sortable: true, },  
              { key: 'sReqrTS', label: this.$t('require.startReqrDate'), sortable: true, variant: 'warning',
                    formatter: value => {
                        return this.$moment(value).format("YYYY-MM-DD")
                }},                               
                { key: 'minDetDate', label: this.$t('release.minDetDate'), sortable: true, variant: 'danger', },                
                { key: 'compNameLocalReqr', label: this.$t('release.compNameLocalReqr'), sortable: true, },                
                { key: 'jobType', label: this.$t('release.jobType'), sortable: true, 
                    formatter: value => {
                        return this.$t(`require.${value}`)
                }}, 
               { key: 'addressReqr', label: this.$t('matchTx.address'), sortable: false, }, 
                { key: 'contType', label: this.$t('release.contType'), sortable: true, },
                { key: 'contSize', label: this.$t('release.contSize'), sortable: true, },
                { key: 'contGrade', label: this.$t('release.contGrade'), sortable: true, },

            ],
            items : [],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15],
            selected: [],
            itemsPostedRels: [],
            fieldsPostedRels: [
                { key: 'relsId', label: this.$t('release.relsId'), sortable: true },  
                { key: 'contId', label: this.$t('container.contId'), sortable: true }, 
                { key: 'contNo', label: this.$t('container.contNo'), sortable: true },  
                { key: 'sRelsTS', label: this.$t('release.startRelsDate'), sortable: true, variant: 'warning',
                    formatter: value => {
                        return this.$moment(value).format("YYYY-MM-DD")
                }},      
                { key: 'detDate', label: this.$t('require.detDate'), sortable: true, variant: 'danger'},                                                   
                { key: 'agent', label: this.$t('release.agent'), sortable: true, }, 
                { key: 'compNameLocalRels', label: this.$t('matchTx.compNameLocalRels'), sortable: true, },                
                { key: 'jobType', label: this.$t('release.jobType'), sortable: true, 
                    formatter: value => {
                        return this.$t(`release.${value}`)
                }}, 
                { key: 'addressRels', label: this.$t('matchTx.address'), sortable: false,},
                // { key: 'contRelsAddress', label: this.$t('matchTx.contRelsAddress'), sortable: false, },   
                { key: 'distLim', label: this.$t('require.distLim'), sortable: true, },             
                { key: 'contType', label: this.$t('release.contType'), sortable: true, },
                { key: 'contSize', label: this.$t('release.contSize'), sortable: true, },
                { key: 'contGrade', label: this.$t('release.contGrade'), sortable: true, },
                { key: 'timestamp', label: this.$t('shipApproval.date'), sortable: true, 
                    formatter: value => {
                        return this.$moment(value).format("DD-MM-YY @ HH:mm")
                }},
                { key: 'status', label: this.$t('matchTx.jobStatus'), variant: 'warning', sortable: true,
                    formatter: value => {
                        return this.$t(`release.${value}`)
                }},
                { key: 'actPostedRels', label: this.$t('matchTx.actions'), variant: 'danger'}
            ],
            totalRowsPostedRels: 1,
            currentPagePostedRels: 1,
            perPagePostedRels: 10,
            pageOptionsPostedRels: [5, 10, 15, { value: 100, text: "Show a lot" }],
            sortBy: 'timestamp',
            sortDesc: true,
            sortDirection: 'asc',
		}
	},

    // computed: {
    //     sortOptions() {
    //     // Create an options list from our fields
    //     return this.tablefields.filter(f => f.sortable).map(f => { return { text: f.label, value: f.key } });
    //     }
    // },
	mounted(){
        this.totalRows = this.items.length
        let compId= localStorage.getItem("compId")
        let userId= localStorage.getItem("userId")
        this.compId = compId
        this.userId= userId  
        this.postQtyList = qtyList
        contIdList(compId, (res)=>{
            if (res.length == 0) {
                this.showContInput = true
            } else {
               this.contList = res 
            }
        })
        transCompList(compId, (res)=>{
            this.transCompList = res
        })
        getData( "Release", "compId" ,this.compId, (res)=>{
            this.itemsPostedRels = res
            this.totalRowsPostedRels = res.length
        })
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) =>{ 
                        showUserLocationOnTheMap(position.coords.latitude, position.coords.longitude, "mapRels" )
                    },
                error => {
                    this.error = `Error: ${error},Locator is unable to find the address. Please type your address manually.`
                }
            );
        } else {
            this.error = error.message
        }   
        var autocomplete = new google.maps.places.Autocomplete(
            document.getElementById('autocompleteRels'),
            {
                bounds: new google.maps.LatLngBounds(
                    new google.maps.LatLng(13.555 , 100.50)
                )
            }
        )
        autocomplete.addListener("place_changed",  ()=>{
            let place = autocomplete.getPlace()
            // console.log("place =>"+ JSON.stringify(place , null , 2))
            let lat = place.geometry.location.lat()
            let lng = place.geometry.location.lng() 
            if (!place.geometry) {
                this.$toasted.show(this.$t("require.fillinMatchedChar"), {theme: 'bubble',   position: 'bottom-right',   type: 'error', duration: 15000});
            } else {
                showUserLocationOnTheMap(lat, lng , "mapRels")          
                this.locRels = {
                    lat : lat,
                    lng : lng
                }
                getAddressFrom(lat, lng, (res)=>{
                    if (res.resp == 'err') {
                        this.error = res.msg
                    } else {
                        this.contRelsAddress = res.msg
                        this.address = res.msg
                    }
                    this.spinner = false
                } )
            }
        })        
	},
	methods:{
        async setContId(value){
            if (value) {
                await getData( 'Container' , 'contId' , value , (res)=>{
                    this.detTS = res[0].detTS
                })                
            }
        },

        locatorButtonPressed(){
            this.spinner =true
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) =>{ 
                        let lat = position.coords.latitude
                        let lng = position.coords.longitude
                        showUserLocationOnTheMap(lat, lng , "mapRels" )
                        this.locRels = {
                            lat : lat,
                            lng : lng
                        }
                        getAddressFrom(lat, lng, (res)=>{
                            if (res.resp == 'err') {
                                this.error = res.msg
                            } else {
                                this.contRelsAddress = res.msg
                                this.address = res.msg
                            }
                            this.spinner = false
                        } )
                    },
                    error => {
                        this.error = "Locator is unable to find the address. Please type your address manually."
                        this.spinner =false
                    }
                );
            } else {
                this.error = error.message
                this.spinner =false
                // console.log(`Your browser does not support geolocation API. Please enter your address`);
            }
        },
        clearAddress(){
            this.address = ''
        },
        resetNoDeliver(){
            if (this.jobType == 'NoDeliver') {
                this.selectedTransCompId = ''
            }
        },
        showAC(){
            if (this.showAutoComplete == false) {
                this.showAutoComplete = true
            } else {
                this.showAutoComplete = false
            }
        },
        offAC(){
            if (this.showAutoComplete == true) {
                this.showAutoComplete = false
            } 
        },

        showMatchingTable( updatedReqrList){
            console.log (`updateReqrList.data (before nextTick) => ${JSON.stringify(updatedReqrList ,null, 2)}`)  
            this.items = updatedReqrList
            this.totalRows = updatedReqrList.length     
            this.isBusy = false
        },
        showModal() {
            this.isBusy = false
            this.$refs['rels-modal'].show()
        },
        async postItModal() {
            let totalRelsCost = relsCost * this.selectedPostQty
            await getBalance(this.compId , async(res)=>{
                if (res < totalRelsCost) {
                    this.balanced = res 
                    this.showAlertWallet = true
                } else {
                    for (let i = 0; i < this.selectedPostQty; i++) {
                        if (i==0) {
                            await saveWithId('Release', this.payload.relsId, this.payload).then(async()=>{  // make a posted RELEASE
                                await updateActive('Container', this.selectedContId, false);
                            }) 
                        } else {
                            let d = new Date()
                            let yyyy = d.getFullYear().toString()
                            let contId = yyyy.substring(2,4)+'CN'+`${Math.floor(Math.random() * (9000000 - 1000000 + 1) + 1000000)}`                            
                            this.payload.contId = contId
                            this.payload.contNo = "Dummy"
                            // this.payload.imageUri = ""  cancel imageUri at Relese
                            this.payload.relsId = `${this.payload.relsId}-${i}`
                            await saveWithId('Release', this.payload.relsId, this.payload).then(()=>{
                                this.payload.relsId = this.payload.relsId.split("-")[0]   // return to without '-'
                            })
                            let dummyContPayload = {
                                compId: this.payload.compId,
                                contId : contId,
                                contNo : "Dummy",
                                contType: this.payload.contType,
                                contSize: this.payload.contSize,
                                maxGross: this.payload.maxGross,
                                tare: this.payload.tare,            
                                contGrade: this.payload.contGrade,
                                // contCertGrade: this.contCertGrade,
                                owner: this.payload.agent,
                                detDate : this.payload.detDate,
                                detTS : this.payload.detTS,
                                // imageUri : "",
                                url6 : [],
                                timestamp: Date.parse(d),
                                active: false
                            }
                            console.log ('Posted dummy containers, payload=>'+JSON.stringify(dummyContPayload , null, 2))
                            await saveWithId('Container', contId, dummyContPayload)
                        }
                    }         
                    this.selectedContId = '' 
                    this.detTS = 0                 
                    await contIdList(this.compId, (res)=>{   // reset contList for next searching in the current page.
                        this.contList = res
                        if (res.length == 0) {
                            this.showContInput = true
                        }
                        this.refreshPostedRelease() 
                        this.$refs['rels-modal'].hide() 
                    })    
                    this.$toasted.show( this.$t("release.postRels"), {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 5000});   
                    let slipId = `${this.$moment().format("YYMMDDHH")}-${getRandomInt(10000 , 90000)}`
                    await uaTxWallet(totalRelsCost * -1, this.compId, slipId, "auto", "expense", "post release" ,this.payload.relsId)                  
                }
            })
        },
        doNotModal() {
            this.$refs['rels-modal'].hide()
        },
        rowSelected(item) {
            this.selected = item
        },
        async selectBatchRow(){
            await this.makeMatchTx(this.selected, (res)=>{
                if (res != "done") {
                    this.$toasted.show(this.$t("require.notMatched"), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});  
                } else {
                    this.items = []
                    this.totalRows = 0
                    this.selected =[]
                    this.selectedContId = ''
                    this.detTS = 0
                    this.jobType = ''
                }
            })
        },
        async makeMatchTx(selectedBkgId, cb){
            let mTxId = `${this.$moment().format("YYMM")}`+'MT'+`${Math.floor(Math.random() * (90000 - 10000 + 1) + 10000)}`
            if (selectedBkgId.length == 0) {
                this.$toasted.show(this.$t("release.noSelectedCont"), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});   
            } else {
                getBalance(this.compId , async(res)=>{
                    if (res < relsCost) {
                        this.balanced = res 
                        this.showAlertWallet = true
                    } else {
                        await getStatusByDocId( "Require",selectedBkgId[0].reqrId, async(res)=>{
                            if (res == "Matched") {
                                this.$toasted.show( this.$t("require.postedMatched"), {theme: 'bubble', type: 'info' , position: 'bottom-center', duration: 10000}); 
                            } else {
                                await this.saveMatchTx(selectedBkgId[0] ,mTxId);
                                contIdList(this.compId, (res)=>{   // reset contList for next searching in the current page.
                                    this.contList = res
                                })
                                this.selectedContId = ''
                                this.detTS = 0
                                let slipId = `${this.$moment().format("YYMMDDHH")}-${getRandomInt(10000 , 90000)}`
                                await uaTxWallet(relsCost * -1, this.compId, slipId, "auto", "expense", "match by release", mTxId)
                                this.$toasted.show(this.$t("release.makeMatchingTx"), {theme: 'bubble', type: 'success' , position: 'bottom-center', duration: 10000});
                                cb("done")  
                            }
                        })
                    } 
                })
            }
        },
        async saveMatchTx( selBkgId ,mTxId){
            let ts = Date.parse(new Date())
            const data = {
                mTxId : mTxId,
                distance: selBkgId.distance,                
                bkgId: selBkgId.bkgId, //this.selectedBkgId,
                compNameLocalRels: this.compNameLocalRels,// selCont.compNameLocal,                
                contRelsAddress:  this.contRelsAddress, //selCont.contRelsAddress,
                locRels: this.locRels,  
                compNameLocalReqr :  selBkgId.compNameLocalReqr,//await compNameLocalByCompId(this.compId),                
                contReqrAddress: selBkgId.contReqrAddress,//this.contReqrAddress,      
                locReqr: selBkgId.locReqr,       
                // jobTypeRels: this.jobType, //selCont.jobType,
                // jobTypeReqr: selBkgId.jobType, //this.jobType,
                // jobTypeRels : this.jobType != 'Either' ? this.jobType : selBkgId.jobType == 'Receive' ? 'Deliver' : selBkgId.jobType == 'Pick-up' ? 'NoDeliver' : 'NoDeliver',
                // jobTypeReqr : selBkgId.jobType != 'Either' ? selBkgId.jobType : this.jobType == 'Deliver' ? 'Receive' : this.jobType == 'NoDeliver' ? 'Pick-up' :'Pick-up',
                jobTypeRels : this.jobType != 'Either' ? this.jobType : selBkgId.jobType == 'Receive' ? 'Deliver' : 'NoDeliver',
                jobTypeReqr : selBkgId.jobType != 'Either' ? selBkgId.jobType : this.jobType == 'Deliver' ? 'Receive' : 'Pick-up',
                transCompId :this.jobType == 'Deliver' ? this.selectedTransCompId : selBkgId.transCompId,
                transStatus : 'waitAccept',
                sRelsTS :Date.parse(this.sRelsDate),
                sReqrTS :selBkgId.sReqrTS,
                msReqr: 'matched',
                jbReqr:'waitAcceptRels',
                actReqr:{
                    cancel:false, 
                    accept: true, 
                    reject:true, 
                    attachSeal:false
                },  
                actRels:{
                    cancel:true, 
                    accept: false, 
                    reject:false, 
                    // attachSeal:false
                },
                stepNo: 1,                                               
                msRels: 'matched',
                jbRels: 'waitAcceptRels',
                compIdRels: this.compId,//selCont.compId,
                compIdReqr : selBkgId.compId,//this.compId,
                userIdRels: this.userId,//selCont.userId,
                userIdReqr: selBkgId.userId,//this.userId,
                relsTS: ts,// selCont.timestamp,
                reqrTS: selBkgId.timestamp,// Date.parse(new Date()),
                // relsId: this.relsId,   
                relsId: "noPost",             
                reqrId: selBkgId.reqrId,
                txSearcher: "Release", 
                timestamp: ts,
                active: true,
                sealNo: "",
                shoreStatus:'waitRequest',                  
                ...this.selectedContData
            }
            await saveWithId('MatchTx', mTxId, data).then(async()=>{
                await updateStatus('Require', selBkgId.reqrId, 'Matched')
                await updateActive('Container', this.selectedContId, false);
                // window.location.reload()
                await saveWithId('jbStatusReqr' , `${mTxId}-${ts}` , {
                    id : mTxId,
                    jbReqr : data.jbReqr,
                    timestamp : ts,
                })
                await saveWithId('jbStatusRels' , `${mTxId}-${ts}` , {
                    id : mTxId,
                    jbRels : data.jbRels,
                    timestamp : ts,
                })
                await saveWithId('transStatus' , `${mTxId}-${ts}` , {
                    id : mTxId,
                    transStatus : 'waitAccept',
                    timestamp : ts,
                })            
            })
        },
        handleSearching(){
            console.log(`this.LocReq`)
            let msg = 'completed'
            if (this.selectedContId ==='') {
                msg = 'release.addSelectedCont'
            } else if (this.contRelsAddress ===''){
                msg = 'release.addContRelsAddress'
            } else if (this.locRels== ''){
                msg = 'release.useGoogleMap'
            } else if (this.distLim ===''){
                msg = 'release.addDistLim'
            } else if (isNaN(parseInt(this.distLim))){
                msg = 'release.distLimNumber'
            } else if (this.jobType ===''){
                msg = 'release.selJobType'
            } else if (this.sRelsDate ===''){
                msg = 'release.selStartRelsDate'
            } else if (Date.parse(this.sRelsDate) > parseInt(this.detTS)){
                msg = 'release.sRelsDateMoreDetDate'
            } else if (this.jobType !=='NoDeliver'){
                if (this.selectedTransCompId == '') {
                   msg = 'release.selTruckComp' 
                } 
            }  
            if (msg === 'completed'){
                agentAtContId(this.selectedContId , async(res)=>{
                    this.items = []   // clear data in the matching table
                    this.isBusy = true  // turn om spiner
                    this.selectedContData = res
                    this.compNameLocalRels =  await compNameLocalByCompId(this.compId)
                    let YYMM = this.$moment().format("YYMM")
                    this.relsId = YYMM+'RL'+`${Math.floor(Math.random() * (90000 - 10000 + 1) + 10000)}`                    
                    let payload = {
                        relsId : this.relsId,
                        // contId : this.selectedContId,
                        distLim : parseInt(this.distLim),
                        contRelsAddress: this.contRelsAddress,
                        locRels: this.locRels,  
                        jobType : this.jobType, // =trans Method
                        transCompId :this.selectedTransCompId,
                        sRelsTS :Date.parse(this.sRelsDate),
                        compId : this.compId,
                        compNameLocalRels : this.compNameLocalRels,
                        userId : this.userId,
                        status: "Release",
                        timestamp: Date.parse(new Date()),                        
                        ...res
                    }
                    // console.log ('payload, rels =>'+JSON.stringify(payload , null, 2))
                    const functionsURL ='https://matchedrels-7gonzgqu6a-as.a.run.app'       
                    axiosPost(functionsURL, payload, (res)=>{
                        if (res.resp == 'err') {
                            this.$toasted.show( `Network Error : ${res.data}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});       
                        } else {
                            if (res.data.length == 0) {
                                this.payload = payload
                                this.showModal()                              
                            } else {
                                this.showMatchingTable(res.data)
                            }
                        }
                    })

                    // await axios.post (functionsURL, payload)
                    // .then((response)=>{
                    //     let respData = response.data
                    //     if (respData.length == 0) {
                    //         this.payload = payload
                    //         this.showModal()                              
                    //     } else {
                    //         this.showMatchingTable(respData)
                    //     }
                    // })
                    // .catch((error) => { 
                    //     console.log(` Network Error => ${error}` )
                    //     this.$toasted.show( `Network Error : ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});       
                    // });
                })                             
            }else{
                this.$toasted.show(this.$t(msg), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 5000});     
            }
        },
        // PostedRelease
        async refreshPostedRelease() {
            await getData( "Release", "compId" , this.compId , (res)=>{
                this.itemsPostedRels = res
                this.totalRowsPostedRels = res.length
            })
            this.selectedTransCompId = ''
            this.sRelsDate = ''
            this.jobType = ''
            this.selectedPostQty = 1
            this.postQtyList = []
        },
        async actPostedRelsCancel(item) {
            this.$bvModal.msgBoxConfirm(this.$t('require.confirmCancelMsg'), {
                title: this.$t('matchTx.plsConfirm'),
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'warning',
                okTitle: this.$t('matchTx.yes'),
                cancelTitle: this.$t('matchTx.no'),
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(async(value) => {
                if (value) {
                    await getStatusByDocId( "Release",item.relsId, async(res)=>{
                        if (res == "Matched") {
                            this.$toasted.show( this.$t("require.postedMatched"), {theme: 'bubble', type: 'info' , position: 'bottom-center', duration: 10000});  
                        } else {
                            await updateActive('Container', item.contId, true).then(async()=>{
                                await contIdList(this.compId, (res)=>{ 
                                    this.contList = res
                                    updateStatus('Release', item.relsId, 'Cancel')
                                    this.refreshPostedRelease()
                                    this.selectedContId = '' 
                                    this.detTS = 0            
                                    this.$toasted.show( this.$t('require.postedCancelled'), {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});  
                                })
                                // window.location.reload()
                            })
                            let slipId = `${this.$moment().format("YYMMDDHH")}-${getRandomInt(10000 , 90000)}`
                            await uaTxWallet(relsCost, this.compId, slipId, "auto", "refund",  "cancel posted release", item.relsId)
                        }
                    })
                } else {
                    return
                }
            })
            .catch(error => {
                this.$toasted.show( `Action-Cancel: ${error}`, {theme: 'bubble', type: 'error' , position: 'bottom-center', duration: 10000});  
            })
        },    


    }
}
</script>
<style scoped>
 .gradient-wy {
   background: linear-gradient(135deg, white, yellow);
 }
.ui.button,
.dot.circle.icon{
    background-color: #138fc0;
    color : white
}
#mapRels {
    position:absolute;
    top:0;
    right:0;
    bottom: 0;
    left: 0;
    background: blue;
}

.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  background: #dfe5fb;
  border: none;
  color: #394066;
  /* text-transform: lowercase;
  font-variant: small-caps; */
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #394066;
}
.divider {
    height: 1px;
    background-color: #0f0f0f;
    margin:5px
}
</style>
